export const tr = {
    'adaptive-banner': 'Uyarlanabilir reklam',
    additions: 'Eklentiler: {additionsList}',
    'banner-id': '№ {id}',
    duration: '{duration} sn'
};
